import { FC } from 'react';
import { Image, ImageFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import * as icons from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';

import { GNElliotWeb } from 'src/Layout';

export interface DrawerSliderItemProps {
  image?: ImageFieldValue;
  iconImage?: ImageFieldValue;
  title?: string;
  content?: string;
  remark?: string;
  iconName?: keyof typeof icons;
  actionLink?: {
    href?: string;
    title: string;
  };
  active?: boolean;
}

const DrawerSliderItem: FC<DrawerSliderItemProps> = ({
  title,
  content,
  remark,
  image,
  iconImage,
  actionLink,
  active,
}) => {
  return (
    <div className={classNames('w-full', GNElliotWeb.className)}>
      <div className="relative w-full">
        <figure className="mt-12 h-[248px] w-full overflow-hidden rounded-3xl bg-blue md:h-[15rem]">
          <Image className="h-full w-full object-cover" field={image} />
        </figure>
        <div className="absolute bottom-[-50px] left-[0] right-[0] mx-auto hidden size-[100px] rounded-full bg-white p-[1.625rem] md:block">
          <div className="flex h-full w-full items-center [&>img]:w-full">
            <Image field={iconImage} />
          </div>
        </div>
      </div>
      <div className="mt-12 md:mt-24">
        <h2 className="mb-6 text-[2rem] font-bold leading-9">{title}</h2>
        <p>{content}</p>
        {remark ? <p className="mt-6">{remark}</p> : null}
        {actionLink?.href ? (
          <Button
            size="l"
            asLink
            variant="secondary"
            iconPlacement="right"
            className="mt-12 inline-flex"
            href={actionLink?.href}
            tabIndex={active ? 0 : -1}
            icon={<JabraIcon Icon={icons.icon_arrow_right} />}
          >
            {actionLink?.title}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default DrawerSliderItem;
